import { render } from "./ClientProjects.vue?vue&type=template&id=edce436a&scoped=true"
import script from "./ClientProjects.vue?vue&type=script&lang=js"
export * from "./ClientProjects.vue?vue&type=script&lang=js"

import "./ClientProjects.vue?vue&type=style&index=0&id=edce436a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edce436a"]])

export default __exports__